import env from '@/config/env'
import request from '@/router/axios'

/**
 * 司机视角--条数
 */
export const postDriverCount = (data) => {
  return request({
    url: env.ferryUrl + '/schedule/forder/driver/count',
    method: 'POST',
    data
  })
}

/**
 * 司机视角--列表
 */
export const postDriverPage = (data) => {
  return request({
    url: env.ferryUrl + '/schedule/forder/driver/page',
    method: 'POST',
    data
  })
}

/**
 * 订单视角--条数
 */
export const postOrderCount = (data) => {
  return request({
    url: env.ferryUrl + '/schedule/forder/order/count',
    method: 'POST',
    data
  })
}

/**
 * 订单视角--列表
 */
export const postOrderPage = (data) => {
  return request({
    url: env.ferryUrl + '/schedule/forder/order/page',
    method: 'POST',
    data
  })
}

/**
 * 根据orderId获取车辆信息列表
 */
export const postVehicleInfo = (data) => {
  return request({
    url: env.ferryUrl + '/schedule/forder/vehicle/info/page',
    method: 'POST',
    data
  })
}

/**
 * 派单在线司机信息
 */
export const getForderDriverInfo = () => {
  return request({
    url: env.ferryUrl + '/schedule/forder/driver-info',
    method: 'get'
  })
}
